export const URL = {
  development: {
    http: "http://localhost:4300",
  },
  // "staging": {
  //   "http": "http://18.206.82.244:4300"
  // },
  staging: {
    http: "https://meanstack.smartdatainc.com:9325",
  },
  prod: {
    http: "https://backend.liaiseapi.com",
  },
};
